<template>
	<div class="modal-dialog shadow-lg mx-0">

		 



		<div class="modal-content rounded-0 border-0 pb-4">
			<button id="heliosNewsletterCloseBtn" type="button" class="close ml-auto mt-3 mr-4" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">
					<svg class="icon icon-xs">
						<use xlink:href="/assets/img/icon-sprite.svg#global.close" xmlns:xlink= "http://www.w3.org/1999/xlink "></use>
					</svg>
				</span></button>
			
			<div class="modal-body"> <!-- v-if="newslettersend==0" -->
				<!-- <form action="" method="post" novalidate="novalidate" id="heliosNewsletterForm" class="needs-validation"> -->

			 <form action="https://web.inxmail.com/helios/subscription/servletv3" method="post" id="NewsletterForm"> <!-- action="https://web.inxmail.com/helios/subscription/servletv3" -->
				<input type="hidden" name="INXMAIL_SUBSCRIPTION" value="Registrierung HeliosSelect"/><!--  "Registrierung HeliosSelect" Helios Masterliste Newsletter -->
				<input type="hidden" name="INXMAIL_HTTP_REDIRECT" :value="'https://select.heliosventilatoren.de'+'/'+ language+'/newsletter/success'"/>
				<input type="hidden" name="INXMAIL_HTTP_REDIRECT_ERROR" :value="'https://select.heliosventilatoren.de'+'/'+ language+'/newsletter/error'"/>
				<input type="hidden" name="INXMAIL_CHARSET" value="UTF-8"/>
					<div id="formnews-msg"></div>
					<div id="formnews-valid-msg"></div>
					<h4 class="font-weight-light mb-4">{{__('lang.newsletter.modal.title')}}</h4>
					<div class="form-row">
						 <!-- <div class="form-group col-12 col-md-8">
							<b-form-group  :label="label.salutation"    class="col-form-label col-form-label-sm" >
								<b-form-radio-group	class="custom-control-label" :options="salutation_options" ></b-form-radio-group>
							</b-form-group>
						</div> -->
						<div class="form-group col-12 col-md-12">
							<label class="col-form-label col-form-label-sm"> {{ label.salutation }}</label>
						</div>
						
						<div class="form-group col-12 col-md-8">
							<div class="row">
								<div class="form-group col-12 col-md-4">
									<div class="custom-control custom-radio">
										<b-form-radio  v-model="input.form_of_address_id" value="Herr" name="Anrede">
											{{ __('lang.newsletter.modal.input.salutation.option.male') }}
										</b-form-radio>
									</div>
								</div>
								<div class="form-group col-12 col-md-4">
										<div class="custom-control custom-radio">
											<b-form-radio v-model="input.form_of_address_id"  value="Frau" name="Anrede">
												{{ __('lang.newsletter.modal.input.salutation.option.female') }}
											</b-form-radio>
										</div>
								</div>
								<div class="form-group col-12 col-md-4">
										<div class="custom-control custom-radio">
											<b-form-radio v-model="input.form_of_address_id"  value="Divers" name="Anrede">
												{{ __('lang.newsletter.modal.input.salutation.option.divers') }}
											</b-form-radio>
										</div>
								</div>
							</div>
						</div>
					</div>
					<div class="form-row">
						
  						<b-form-group 
							class="form-group col-12 col-md-6"
							:label="label.firstname" 
							label-for="input_firstname" 
							label-class="col-form-label col-form-label-sm text-secondary" 
							:invalid-feedback="invalidFeedback.firstname"
						>
							<b-form-input type="text" class="form-control border" v-model="input.first_name" id="input_firstname" name="Vorname"></b-form-input>
						</b-form-group>
						<b-form-group 
								class="form-group col-12 col-md-6"
								:label="label.lastname" 
								label-for="input_lastname" 
								label-class="col-form-label col-form-label-sm text-secondary" 
								:invalid-feedback="invalidFeedback.lastname"
							>
								<b-form-input type="text" class="form-control border" v-model="input.last_name" id="input_lastname" name="Nachname"></b-form-input>
						</b-form-group>
					</div>
					<div class="form-row">
						<b-form-group 
									class="form-group col-12 col-md-6"
									:label="label.email" 
									label-for="input_email" 
									label-class="col-form-label col-form-label-sm text-secondary required" 
									:invalid-feedback="invalidFeedback.email"
									:state="emailState"
								>
								<b-form-input type="text"  class="form-control border" v-model="input.email" id="input_email" autocomplete="email" name="email"></b-form-input>
							</b-form-group>
					</div>
					<div class="form-row">
						<div class="form-group col-12">
							<div class="custom-control custom-checkbox">
								<input name="PrivacyNL" required="required" type="checkbox" id="PrivacyNL" value="1" class="custom-control-input"  v-model="privacy">
								<label for="PrivacyNL" class="custom-control-label">{{ __('lang.newsletter.modal.agree_1') }} <a href= "https://heliosventilatoren.de/de/datenschutz " target="_blank" rel="noopener" class="text-primary">{{ __('lang.newsletter.modal.agree_policy') }}</a>
									{{ __('lang.newsletter.modal.agree_2') }}</label>
							<!-- 	<div class="invalid-feedback">{{ __('lang.newsletter.modal.invalid_feedback.agree_confirm') }}</div> -->
								<div class="invalid-feedback" v-if="showValidationMessage" >{{ __('lang.newsletter.modal.invalidfeedback.agree_confirm') }}</div>
							</div>
						</div>
					</div>
					<div class="form-row">
						<div class="form-group col-12">
							<div class="custom-control custom-checkbox">
								<input name="NewsletterNL" required="required" type="checkbox" id="NewsletterNL" value="1" class="custom-control-input" v-model="input.nl">
								<label for="NewsletterNL" class="custom-control-label">{{__('lang.newsletter.modal.abo')}}</label>
							</div>
						</div>
					</div>  
					<div class="frc-captcha" data-sitekey="FCMQMF2A9M34Q6HJ" data-puzzle-endpoint="https://eu-api.friendlycaptcha.eu/api/v1/puzzle"></div>   
					
					
					<div class="form-row my-4">
						<div class="form-group col-12 col-md-6 order-2 order-md-1">
							<button id="heliosNewsletterReset" class="btn btn-gray-50 text-white btn-block" type="reset" @click="resetNewsletterUser">
								<svg class="icon">
									<use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink= "http://www.w3.org/1999/xlink "></use>
								</svg>{{ __('lang.btn.reset') }}
							</button>
						</div>
						<div class="form-group col-12 col-md-6 order-1 order-md-2">
							<button name="submit" type="submit" value="submit" id="heliosNewsletterSubmit" class="btn btn-primary btn-block border-0">  <!--@click="subscribenewsletter($event)"  -->
								<svg class="icon">
									<use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink= "http://www.w3.org/1999/xlink "></use>
								</svg>{{ __('lang.newsletter.modal.btn.registerforfree') }}
							</button>
						</div>
					</div>
					<div class="mb-4">{{ __('lang.newsletter.modal.input_required') }}</div>
					
				
				</form>
			</div>
			<!-- <div class="modal-body" v-else>
				<div id="formnews-msg" style="visibility: visible; display: block;">
					<h4 class="font-weight-light mb-4">Vielen Dank für Ihre Anmeldung</h4><p>Bitte bestätigen Sie noch Ihre E-Mail Adresse in der Mail, die wir Ihnen soeben
	            					geschickt haben.</p><button id="heliosNewsletterReset" class="btn btn-gray-50 text-white btn-block" type="reset">
									<svg class="icon">
										<use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
									</svg>Zurücksetzen
								</button></div>
			</div> -->
		</div>
	</div>
</template>

<script>
//import log from './services/logger/index'
import globalsApi from './services/api/globals'

export default {
	props: {
		newsletteruser: Object // Define the prop type as Object
		} ,
    data() {
      	return {
			label: {
				firstname: this.__('lang.newsletter.modal.input.firstname'),
				lastname: this.__('lang.newsletter.modal.input.lastname'),
				
				salutation: this.__('lang.newsletter.modal.input.salutation'),
				email: this.__('lang.newsletter.modal.input.email'),
			},
			/* salutation_options: [
				{ value: '1', text: this.__('lang.newsletter.modal.input.salutation.option.male') },
				{ value: 2, text: this.__('lang.newsletter.modal.input.salutation.option.female')},
				{ value: 5, text: this.__('lang.newsletter.modal.input.salutation.option.divers')}
				], */
			salutation_options: [
				{ value: 'Herr', text: this.__('lang.newsletter.modal.input.salutation.option.male') },
				{ value: 'Frau', text: this.__('lang.newsletter.modal.input.salutation.option.female') },
				{ value: 'Divers', text: this.__('lang.newsletter.modal.input.salutation.option.divers') }
			],
			
			invalidFeedback: {
				firstname: this.__('lang.newsletter.modal.invalidFeedback.firstname'),
				lastname: this.__('lang.newsletter.modal.invalidFeedback.lastname'),

				salutation: this.__('lang.newsletter.modal.invalidFeedback.salutation'),
				email: this.__('lang.newsletter.modal.invalidFeedback.email'),
				},
			input: {
					email: '',
					form_of_address_id: '',
					first_name: '',
					last_name: ''
				},
			privacy: false,
			showValidationMessage: false,
			newslettersend:0
			
		

			
			
			
    	}
	},
	methods: {
		validateEmail(email) {
			var re = /\S+@\S+\.\S+/;
			return re.test(email);
		},
	
		subscribenewsletter(evt) { 
			
			//evt.preventDefault();
			this.newslettersend = 1
			document.getElementById('NewsletterForm').submit();
			


			// Programmatically submit the form.
			//--this.$refs.NewsletterForm.submit();
			//this.$store.dispatch('alert/setAlert', { type: 'success', message: this.__('lang.newsletter.modal.subscribe.success') + ' ' + this.__('lang.newsletter.modal.subscribe.notice') })

			/* this.$store.dispatch('alert/setAlert', { type: 'warning', message: 'This feature is still in development' })
			if(!this.showValidationMessage) document.getElementById('heliosNewsletterCloseBtn').click();  */


 			/* 
			await axios.post('/subscribenewsletter', { recipient: this.input }).then(res => {
				//console.log('subscribenewsletter:', res.data)
				console.log('subscribenewsletter:', res) 
				this.$store.dispatch('alert/setAlert', { type: 'success', message: this.__('lang.newsletter.modal.subscribe.success') + ' ' + this.__('lang.newsletter.modal.subscribe.notice') })
				this.resetNewsletterUser();
			}).catch(function (error) {
				 console.log('mailresdata error:', error) 
				 this.$store.dispatch('alert/setAlert', { type: 'warning', message: this.__('lang.newsletter.modal.subscribe.error') })
			})  */
			

		},
		resetNewsletterUser() {
			const newNewsletterUser = {
				email: '', 
				form_of_address_id: '',
				first_name: '',
				last_name: ''
			};

			this.$emit("reset-newsletter-user", newNewsletterUser);
		}
	},
	computed: {
		user: {
			get() {
				return this.$store.state.user.user
			},
			set(value) {
				this.$store.commit('user/updateUser', value)
			}
		},
		emailState() {
			if (this.input.email == null || this.input.email == '') return true
			return this.validateEmail(this.input.email)
		},
		language: function () {
			return  this.$lang().locale
		}
    },
	watch: {
		privacy(newVal) {
			this.showValidationMessage = !newVal;
			console.log('privacy watch', this.showValidationMessage)
		},
		
		newsletteruser: {
			immediate: true,
			deep: true,
			handler(newVal) {
				
				/* if (this.newsletteruser.email != null && this.newsletteruser.email != '' && this.validateEmail(this.newsletteruser.email)) {
					console.log('newsletter watch', this.newsletteruser.email)

					this.input.email = newVal.email
					this.input.form_of_address_id = newVal.form_of_address_id
					this.input.first_name = newVal.first_name
					this.input.last_name = newVal.last_name 
					
				}
				else {
					Object.values(this.newsletteruser).forEach(val => {
						for (key in val) val[key] = ''
					})
				}*/

				this.$nextTick(() => {
					this.input= newVal; // Manually updating the value
					
				});
				
				
			}
		}
    	
	},
	mounted() {	
		/* console.log('newsletter mounted')
	 	if (this.user.auth) {
			console.log('newsletter mounted auth')
			this.input = this.user

			if (this.newsletteruser.email != null && this.newsletteruser.email != '' && this.validateEmail(this.newsletteruser.email)) {
				console.log('newsletter mounted', this.email)
				this.input.email = this.newsletteruser.email;
			} 
		  } */
		/*
		else {
			console.log('newsletter mounted not auth')
			this.input = {}
		}  */
		
			

	}
  }
</script>